<template>
    <div class="ui field">
        <label>Filename</label>
        <div class="ui fluid selection dropdown">
            <input type="hidden" name="file_suggestion_id">
            <i class="dropdown icon"></i>
            <div class="default text" v-if="hasSuggestions && definition.allows_custom_filenames">I want a different filename</div>
            <div class="default text" v-else-if="hasSuggestions && !definition.allows_custom_filenames">Choose a filename</div>
            <div class="default text" v-else>Loading...</div>

            <div class="menu" v-if="hasSuggestions">
                <div class="item" data-value="0" v-if="definition.allows_custom_filenames">
                    I want a different filename
                </div>
                <div class="item" v-for="fileSuggestion in fileSuggestions" :key="fileSuggestion.name" v-bind:data-value="fileSuggestion.name">
                    {{ fileSuggestion.name }} - {{ formatCurrency(fileSuggestion.donation_total) }}
                </div>
            </div>
            <div class="menu" v-else>
                <div class="item">
                    Loading...
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'campaign',
        'definition'
    ],

    data() {
        return {
            fileSuggestions: [],
            hasSuggestions: false,

            $dropdown: null
        };
    },

    mounted() {
        this.prepareComponent();
    },

    updated() {
        this.$dropdown.dropdown('setting', {
            onChange: (value, text) => {
                if (value <= 0) {
                    this.$emit('change', null, text);
                }
                else {
                    this.$emit('change', value, text);
                }
            }
        });
    },

    watch: {
        definition: function() {
            this.hasSuggestions = false;
            this.reloadSuggestions();
        }
    },

    methods: {
        formatCurrency(money) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
        },

        prepareComponent() {
            this.$dropdown = $(this.$el).find('.dropdown');

            this.reloadSuggestions();
        },
        
        reloadSuggestions() {
            axios.get('/file-definitions/' + this.definition.id + '/file-suggestions')
                .then(response => {
                    this.fileSuggestions = response.data;
                    this.hasSuggestions = true;

                    if (this.definition.allows_custom_filenames) {
                        this.$emit('change', null, 'I want a different filename');
                    } else {
                        this.$emit('change', this.fileSuggestions[0].name, this.fileSuggestions[0].name)
                    }
                })
        }
    }
}
</script>